// Onboarding top row: 44px back button + the progress bar (SPEC §3). Sits at the prototype's top 46 (safe area aware).
//   <OnbTopBar pct={34} onBack={back} />                     plain background
//   <OnbTopBar pct={93} onBack={back} overScene />            over a picture: glass back button, lighter track
//   <OnbTopBar pct={97} />                                    no back button (O9)
import { Icon } from './icons';
import { ProgressBar } from './ProgressBar';

export interface OnbTopBarProps { pct: number; onBack?: () => void; overScene?: boolean }

export function OnbTopBar({ pct, onBack, overScene }: OnbTopBarProps) {
  return (
    <div style={{
      position: 'relative', flex: 'none', zIndex: 2, display: 'flex', alignItems: 'center', gap: 10, height: 44,
      marginTop: 'calc(var(--xm-top) + 2px)', padding: `0 calc(20px + var(--xm-sar)) 0 calc(${onBack ? 12 : 20}px + var(--xm-sal))`,
    }}>
      {onBack && (
        <button type="button" aria-label="Back" onClick={onBack} style={{
          flex: 'none', width: 44, height: 44, borderRadius: 22, display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: overScene ? 'rgba(15,14,12,0.5)' : 'transparent', color: '#F5F1EA',
        }}>
          <Icon name="back" size={22} />
        </button>
      )}
      <ProgressBar pct={pct} overScene={overScene} />
    </div>
  );
}
